export default function formatOrgNr(orgnr: string | number): string {
  const input = `${orgnr}`;
  return input.length === 9 ? format(input) : input;
}

function format(orgnr: string): string {
  return `${orgnr.substr(0, 3)} ${orgnr.substr(3, 3)} ${orgnr.substr(6)}`;
}
